import { useEffect } from 'react'
import { Route, Routes } from 'react-router'
import { useDispatch, useSelector } from 'react-redux'
import CommonFallback from '@/shared/components/CommonFallback'
import { selectOrganizationsInitialized } from './organizationsManagementSelectors'
import Index from './OrganizationShow/Index'
import Edit from './OrganizationForm/Edit'
import OfferEdit from './OfferForm/OfferEdit'
import NettingUpdaterPage from './NettingUpdater/NettingUpdaterPage'
import { selectAuthData } from '@/containers/Login/AuthSelectors'
import useBusinessType from '@/shared/hooks/useBusinessType'
import EnergyShow from './OrganizationShow/Energy/EnergyShow'
import InsuranceShow from './OrganizationShow/Insurance/InsuranceShow'
import TelecomShow from './OrganizationShow/Telecom/TelecomShow'
import { organizationsManagementActions } from './organizationsManagementSagas'

const formTypes = {
  energie: EnergyShow,
  assurance: InsuranceShow,
  telecom: TelecomShow,
  default: CommonFallback,
}

const OrganizationRouter = () => {
  const dispatch = useDispatch()
  const { loaderRoutesEnergy, loaderRoutes, loaderRoutesInsurance } = useSelector(selectAuthData)
  const { getApplicationUrl, type } = useBusinessType({
    loaderRoutesEnergy,
    loaderRoutes,
    loaderRoutesInsurance,
    modulesStatuses: {},
    modulesStatusesEnergy: {},
    modulesStatusesInsurance: {},
  })
  const initUrl = getApplicationUrl('organizations-management')
  const initialized = useSelector(selectOrganizationsInitialized)
  const FormToLoad = formTypes[type] || formTypes.default

  useEffect(() => {
    if (!initUrl) {
      return
    }
    dispatch({ type: organizationsManagementActions.INITIALIZE, enqueue: true, url: initUrl })
  }, [])

  if (!initialized || !initUrl) {
    return <CommonFallback />
  }

  return (
    <Routes>
      <Route exact path='' element={<Index />} />
      <Route exact path='add' element={<Edit />} />
      <Route path='edit/:id' element={<Edit />} />
      <Route path=':id' element={<FormToLoad />} />
      <Route path=':providerUuid/offers/add' element={<OfferEdit />} />
      <Route path=':providerUuid/offers/:offerId/edit' element={<OfferEdit />} />
      <Route path=':providerUuid/netting' element={<NettingUpdaterPage />} />
    </Routes>
  )
}

export default OrganizationRouter
